"use client"; // Ensures the component runs on the client side

import { useState } from "react";
import { Link } from 'react-router-dom';

export default function BuyTicket() {
  // State for dynamic content
  const [whatsapp] = useState({
    title: "No te pierdas de nada! Únete a nuestra comunidad de WhatsApp",
    description:
      "¿Quieres estar al tanto de los eventos culturales, deportivos y de turismo más vibrantes? DJs, bailarines, músicos, profesores y experiencias únicas te esperan cada semana. Presiona en el botón o escanea el código QR para unirte a nuestro grupo de WhatsApp y no te pierdas ninguna actualización.",
    buttons: [
      { id: 1, text: "Enlace de WhatsApp", link: "https://chat.whatsapp.com/EwuN5XoUIGd9RR18PGxjjp", class: "buy-ticket__btn-1" }
    ],
  });

  return (
    <>
      {/* Buy Ticket Start */}
      <section className="buy-ticket">
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <div
                className="buy-ticket__left wow fadeInLeft"
                data-wow-delay="100ms"
              >
                <h3 className="buy-ticket__title">{whatsapp.title}</h3>
                <p className="buy-ticket__text">{whatsapp.description}</p>
                <div className="buy-ticket__btn-box">
                  {whatsapp.buttons.map((button) => (
                    <Link
                      key={button.id}
                      to={button.link}
                      className={`${button.class} thm-btn`}
                      target="_blank"
                    >
                      {button.text}
                      <span className="icon-arrow-right"></span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div
                className="buy-ticket__right wow fadeInRight"
                data-wow-delay="300ms"
              >
                <div className="buy-ticket__img">
                  <img src="https://storage.googleapis.com/ecueventos000-imgs/ecueventos000-whatsapp-qr.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Buy Ticket End */}
    </>
  );
}
